export const FREQUENCIES = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Weekly - End', value: 'weekly_end' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Monthly - End', value: 'monthly_end' },
  { label: 'Yearly', value: 'yearly' },
  { label: 'Yearly - Middle', value: 'yearly_middle' },
  { label: 'Yearly - End', value: 'yearly_end' },
];